import { getFirestore } from '../../system/firebase';
import { ADMIN_CONSOLE_PAGE_SIZE, USER_TYPE_JS } from '../constants';

import { convertFirebaseTimestampsToDate } from '../dateHelper';

// import { format as formatDate } from 'date-fns';
// import _sub from 'date-fns/sub';
// import _getTime from 'date-fns/getTime';
// import format from 'date-fns/format';

import _size from 'lodash/size';
import { format } from 'date-fns';

export const loadTotalCounts = async () => {
    const db = getFirestore();
    const statDoc = await db.collection('stats').doc('all').get();
    return statDoc.exists ? statDoc.data() : {};
};
export const loadTodaysCount = async () => {
    const db = getFirestore();
    console.log(format(new Date(), 'yyyy-MM-dd'));
    const statDoc = await db.collection('stats').doc(format(new Date(), 'yyyy-MM-dd')).get();
    return statDoc.exists ? statDoc.data() : {};
};

export const loadUsersData = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let usersRef = db.collection('users').where('type', '==', USER_TYPE_JS).orderBy('createDt', 'desc').limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) usersRef = usersRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const userSnapshots = await usersRef.get();
        userSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = userSnapshots.docs[userSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
    }
};
export const loadEmployersData = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let dataRef = db.collection('employers').orderBy('createDt', 'desc').limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) dataRef = dataRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const dataSnapshots = await dataRef.get();
        dataSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['subscriptionDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = dataSnapshots.docs[dataSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
    }
};
export const loadFeedback = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let dataRef = db.collection('feedback').orderBy('createDt', 'desc').limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) dataRef = dataRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const dataSnapshots = await dataRef.get();
        dataSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = dataSnapshots.docs[dataSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
    }
};

export const loadSurveysResult = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE, userType }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let usersRef = db.collection('surveys').where('userType', '==', userType).where('updateDt', '!=', null).orderBy('updateDt', 'desc').limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) usersRef = usersRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const userSnapshots = await usersRef.get();
        userSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = userSnapshots.docs[userSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
    }
};

export const loadCustomerAdvertisments = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let dataRef = db.collection('ad2').where('purchaseDt', '!=', null).orderBy('purchaseDt', 'desc').limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) dataRef = dataRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const dataSnapshots = await dataRef.get();
        dataSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['endDt', 'startDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = dataSnapshots.docs[dataSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
    }
};
export const loadWaitListData = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let usersRef = db.collection('waitList').orderBy('createDt', 'desc').limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) usersRef = usersRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const userSnapshots = await usersRef.get();
        userSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = userSnapshots.docs[userSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
    }
};
export const loadContactUsData = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let usersRef = db.collection('contactUsForms').orderBy('createDt', 'desc').limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) usersRef = usersRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const userSnapshots = await usersRef.get();
        userSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = userSnapshots.docs[userSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
    }
};
export const loadActivityStatsHired = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE, month }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let usersRef = db.collection('monthHiredCandidates').where('month', '==', month).limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) usersRef = usersRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const userSnapshots = await usersRef.get();
        userSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = userSnapshots.docs[userSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
        return { result: [], lastDoc: {} };
    }
};
export const loadActivityStatsApplied = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE, month }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let usersRef = db.collection('appliedJobs').where('month', '==', month).limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) usersRef = usersRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const userSnapshots = await usersRef.get();
        userSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = userSnapshots.docs[userSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
    }
};
export const loadActivityStatsInterviews = async ({ queryCursors, mode = 'next', pageSize = ADMIN_CONSOLE_PAGE_SIZE, month }) => {
    try {
        const db = getFirestore();
        const cursorCount = _size(queryCursors);
        const list = [];
        let lastDoc = null;

        //---------------------------------------------------------------------
        // set up query based on mode and cursor
        //---------------------------------------------------------------------
        let usersRef = db.collection('interviews').where('month', '==', month).orderBy('createDt', 'desc').limit(pageSize);
        if (mode === 'next') {
            // next page
            if (cursorCount > 0) {
                // on page 1 or after, start from the last doc of previous page
                lastDoc = queryCursors[cursorCount - 1];
            }
        } else {
            // previous page
            if (cursorCount > 2) {
                // on page 3 or after, start from the last doc of two pages back
                lastDoc = queryCursors[cursorCount - 3];
            }
        }
        if (lastDoc) usersRef = usersRef.startAfter(lastDoc);

        //---------------------------------------------------------------------
        // read collection
        //---------------------------------------------------------------------
        const userSnapshots = await usersRef.get();
        userSnapshots.forEach(doc => {
            let data = doc.data();
            data = convertFirebaseTimestampsToDate(data, ['createDt', 'startDt', 'endDt']);
            list.push({ ...data, uid: doc.id });
        });

        const newLastDoc = userSnapshots.docs[userSnapshots.docs.length - 1];

        return { result: list, lastDoc: newLastDoc };
    } catch (error) {
        console.log({ error });
        return { result: [], lastDoc: {} };
    }
};

export const loadEmployerDataById = async ({ empId }) => {
    try {
        const db = getFirestore();
        let data = (await db.collection('employers').doc(empId).get()).data();
        return data;
    } catch (error) {
        console.log({ error });
    }
};
